import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
export const Svg = styled.svg.withConfig({
  displayName: "tenant__Svg",
  componentId: "sc-1ve3mpb-0"
})([".cls-1,.cls-2{fill:none;stroke:", ";stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:1.2px;}.cls-2{stroke-width:0.4px;}.cls-3{fill:", ";}"], p => p.color, p => p.color);
export default (({
  color = 'currentColor'
}) => /*#__PURE__*/React.createElement(Svg, {
  viewBox: "0 0 40 40",
  color: color
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M28.87,25.12h.73a5.85,5.85,0,1,0-1.32-11.53,6,6,0,0,0-11.55-1.32,4.62,4.62,0,0,0-2.26-.61,4.67,4.67,0,0,0-4.67,4.67c0,.13,0,.26,0,.39a4.26,4.26,0,1,0-1,8.4h3"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: "14.74",
  y: "18.76",
  width: "10.53",
  height: "12.72"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-2",
  x1: "17.74",
  y1: "21.76",
  x2: "20.26",
  y2: "21.76"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: "22.26",
  cy: "21.76",
  r: "0.6"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-2",
  x1: "17.74",
  y1: "25.12",
  x2: "20.26",
  y2: "25.12"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: "22.26",
  cy: "25.12",
  r: "0.6"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-2",
  x1: "17.74",
  y1: "28.48",
  x2: "20.26",
  y2: "28.48"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-3",
  cx: "22.26",
  cy: "28.48",
  r: "0.6"
})));